<template>
  <tr v-if="secondRow">
    <td colspan="10" class="no-border">
      <div id="coll1" class="collapse in" aria-expanded="true" style="" v-if="rows.length > 0">
        <table class="table no-margin">
          <tbody>
          <tr v-for="row in rows">
            <td style="width:25%">{{row.str_name}} ({{row.str_store_number}})<br>{{row.str_address_street}} {{row.str_address_street_number}}, {{row.str_address_city}}</td>
            <td style="width:25%;">
              <div v-if="row.message != null && row.message !== ''" class="callout callout-warning small no-margin" style="padding:5px 10px">
                <i class="fa fa-warning mr-5"></i>{{row.message}}
              </div>
              <div v-if="row.companyChildOrderExists" class="callout callout-warning small no-margin" style="padding:5px 10px">
                <i class="fa fa-warning mr-5"></i>{{'rebooking_conflict_existing_child_order' | translate }}
              </div>
            </td>
            <td class="text-right">
              <span class="small text-muted">{{'shipping_country' | translate }}:</span><br />
              <span v-if="validCountries.includes(row.country)">
                <img class="img-responsive img-channel pull-right" :src="`/static/img/country_${row.country}.svg`" alt="">
              </span>
              <span v-else>
                {{ row.country }}
              </span>
            </td>
            <td class="text-right">
              <span class="small text-muted">{{ 'stock_company' | translate }}:</span>
              <br/>
              {{ row.num_stock }}
            </td>
            <td class="text-right">
              <span class="small text-muted">{{ 'vendor_price' | translate }}:</span>
              <br/>
              {{ row.s_sale_price | currency }}
            </td>
            <td :class="[loading ? 'text-muted' : '', 'text-right']">
              <button :disabled="loading || row.companyChildOrderExists" class="btn btn-sm btn-info" @click="retry(item, row)" :title="retryButtonTitle(row)">
                {{'retry_line' | translate}}<i :class="['fa fa-refresh ml-5', loading ? 'fa-spin' : '']"></i>
              </button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div v-else class="callout callout-info">
        <i class="fa fa-info-circle mr-5"></i>{{'no_stores' | translate}}
      </div>
    </td>
  </tr>
</template>

<script>
  import {translate} from '../../../filters';

  export default {
    props: ['secondRow', 'type', 'rows', 'item'],
    name: "store-row",
    data () {
      return {
        loading: false,
        validCountries: ['DE', 'AT', 'FR', 'NL', 'UK', 'GB', 'BE', 'IT', 'ES']
      }
    },
    methods: {
      retry (item, store) {
       this.loading = true
        API.put(`monitoring/order/line/${item.order_item_line_id}/retry`, {str_store_number: store.str_store_number, ti_mp_order: store.ti_mp_order})
          .then(response => {
            this.$store.commit('pushAlert', {dismiss: 4, type: 'success', message: `Process Started`, icon: 'icon fa fa-check', show: true})
            this.loading = false
            this.$emit('deleteRow', item)
          })
          .catch(error => {
            this.$store.commit('pushAlert', {dismiss: 4, type: 'danger', message: error.response.data.message, icon: 'fa fa-ban', show: true})
            this.loading = false
          })
      },
      retryButtonTitle(row) {
        return row.companyChildOrderExists ? translate('rebooking_conflict_existing_child_order') : '';
      }
    },
    watch: {
      rows () {}
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/tools/TableRows/storeRow.vue